import { Box } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import IntroView from '../../modules/intro';
import { dashboard } from '../../router/Routes';
import ModalComponent from '../modals/Modal';
import BreadcrumbTemplate from './Breadcrumb';

const ContainerTemplate = ({ children, active, routes, subtitle }) => {
  let history = useHistory();

  const loginStore = Redux.useSelector((state) => state.login);
  const templateStore = Redux.useSelector((state) => state.template);

  const [openModalIntro, setOpenModalIntro] = React.useState(false);

  React.useEffect(() => {
    const { vistas, isRoot } = loginStore;
    if (isRoot) {
      setOpenModalIntro(false);
      return;
    }

    if (active.id === '1x1') return;

    const existe = vistas.some((row) => row.id === active.id);
    if (!existe) {
      history.push(dashboard.to);
    }

    setOpenModalIntro(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setOpenModalIntro(templateStore.settings.intro);
  }, [templateStore.settings.intro]);

  return (
    <Box sx={{ width: '100%' }}>
      <BreadcrumbTemplate active={active} routes={routes} subtitle={subtitle} />
      {children}
      <ModalComponent
        id="modalIntro"
        open={openModalIntro || templateStore.settings.guia}
        maxWidth="lg"
        onClose={() => setOpenModalIntro(!openModalIntro)}
      >
        <IntroView />
      </ModalComponent>
    </Box>
  );
};

export default ContainerTemplate;
